import { useTranslations } from '@lang';
import SpaClasses from '@routes/SpaClasses/SpaClasses';
import * as entityActions from '@store/entity/actions';
import { NormalizedStore } from '@store/entity/entity.types';
import { NextPage, NextPageContext } from 'next';
import NextSeo from 'next-seo';
import Head from 'next/head';
import { Property } from 'shared-types/Property';

type SpaClassesProps = {
  language: string;
  property: Property;
  url: string;
};

const SpaClassesPage: NextPage<SpaClassesProps> = ({ url, language, property }) => {
  const { t } = useTranslations();
  const pageName = t('app.spaClasses');

  return (
    <>
      <Head>
        <title>{pageName}</title>
      </Head>
      <NextSeo
        config={{
          openGraph: {
            title: pageName,
            locale: language,
            url,
          },
        }}
      />
      <SpaClasses property={property} language={language} />
    </>
  );
};

type SpaClassesInitialProps = {
  language: string;
  property: Property;
  store: NormalizedStore;
  url: string;
} & NextPageContext;

SpaClassesPage.getInitialProps = async ({
  language,
  property,
  store,
  url,
}: SpaClassesInitialProps): Promise<SpaClassesProps> => {
  if (property.homepage) {
    await entityActions.fetchCategories(property.id, language)(store.dispatch);
  }

  return {
    url,
    language,
    property,
  };
};

export default SpaClassesPage;
